<div class="generic-modal-root" style="padding: 20px;">
  <ngx-datatable
          class='material striped datatable'
          [rows]='workflowRuns'
          [columnMode]='"force"'
          [headerHeight]='40'
          [footerHeight]='20'
          [scrollbarV]="true"
          [rowHeight]="40"
          [reorderable]="true"
          [sorts]="[{prop: 'applicationName', dir: 'asc'}]"
          [messages]="{emptyMessage:'Nothing to see here'}">						


    <ngx-datatable-column prop="workflowName" [sortable]="true" [width]="200" [minWidth]="200" [maxWidth]="400">
      <ng-template let-column="column"  ngx-datatable-header-template let-sort="sortFn">
          <span (click)="sort()">Workflow Name</span>
      </ng-template>
      <ng-template let-row="row" ngx-datatable-cell-template >
        {{row.workflowName}}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="status" [sortable]="true" [minWidth]="200" [maxWidth]="400">
      <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
        <span (click)="sort()" >
          Status
        </span>
      </ng-template>
      <ng-template let-row="row" ngx-datatable-cell-template >
        {{row.statusName}}
      </ng-template>
    </ngx-datatable-column>  		   
      
    <ngx-datatable-column prop="conclusion" [sortable]="true" [width]="200" [minWidth]="200" [maxWidth]="400" >
      <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
        <span (click)="sort()" >
          Conclusion
        </span>
      </ng-template>
      <ng-template let-row="row" ngx-datatable-cell-template >
        {{row.conclusionName}}
      </ng-template>
    </ngx-datatable-column>
  </ngx-datatable>
  
  <div class="row" style="margin: 0;">
      <button (click)="close()" class="btn btn-success" style="margin-top:50px;">Close</button>
  </div>
</div>